import clsx from "clsx";
import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomTextField from "../TextField";
import ClearButton from "./ClearButton";

const useStyles = makeStyles(theme => ({
  textField: {
    "& .MuiInputLabel-formControl": {
      top: -7,
      "&.Mui-focused": {
        top: 0,
      },
    },
  },
}));

const ProgressIndicator = ({ disabled }) => (
  <CircularProgress
    size="1rem"
    sx={{
      opacity: disabled ? 0.5 : 1
    }}
  />
);

const SearchIcon = () => (
  <i className="nc-icon nc-zoom-split" />
);

const SearchTextInput = ({
  className,
  disabled,
  onChange,
  searching,
}) => {
  const classes = useStyles();

  const [value, setValue] = useState("");

  const clear = () => {
    update("");
    flush();
  };

  const debounceOnChange = useCallback(
    debounce(value => {
      onChange?.(value);
    }, 1000),
    []
  );

  const flush = () => debounceOnChange.flush();

  const update = (newValue) => {
    setValue(newValue);
    debounceOnChange(newValue.trim());
  };

  return (
    <CustomTextField
      customClass={clsx([classes.textField, className])}
      disabled={disabled}
      endAdornment={
        (searching && value !== "") ? (
          <ProgressIndicator disabled={disabled} />
        ) : (value === "") ? (
          <SearchIcon />
        ) : (
          <ClearButton disabled={disabled} onClear={clear} />
        )
      }
      label={<FormattedMessage id="btn.search" />}
      onChange={e => update(e.target.value)}
      onKeyDown={e => (e.key === "Enter") && flush()}
      value={value}
    />
  );
};

export default SearchTextInput;
